import { createContainer } from "unstated-next";
import { useAiSaasStore } from "./useAISaasStore";

export const AISaasContainer = createContainer(useAiSaasStore);
export const { Provider: AISaasProvider, useContainer: useAISaasContainer } = AISaasContainer;
